import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpGetClient } from "../../protocols/http/http-get-client";
import { FetchUserManagementData } from "../../../domain/useages/user-management/fetch-user-management-data";
import Swal from "sweetalert2";

export class RemoteFetchUserManagementData implements FetchUserManagementData {
  constructor(
    private readonly url: string,
    private readonly httpGetClient: HttpGetClient
  ) {}

  async fetch(params?: FetchUserManagementData.Params): Promise<any> {
    const httpResponse = await this.httpGetClient.get({
      url: this.url,
      query: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    } else {
      Swal.fire({
        timer: 3000,
        icon: "error",
        text: "Error Fetching User Date",
      });
    }
  }
}
